import { render, staticRenderFns } from "./EmptyMessage.vue?vue&type=template&id=1e978b1e&scoped=true&"
import script from "./EmptyMessage.vue?vue&type=script&lang=ts&"
export * from "./EmptyMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e978b1e",
  null
  
)

export default component.exports